export const ONETRUST_ALERT_BOX_COOKIE_NAME = "OptanonAlertBoxClosed";
export const ONETRUST_CONSENT_COOKIE_NAME = "OptanonConsent";
export const ONETRUST_COOKIE_DOMAIN = ".clearpay.co.uk";
export const ONETRUST_FOOTER_CTA_NAME = "Onetrust";
export const ONETRUST_FOOTER_CTA_TEXT = "Cookie preferences";

export const deleteCookie = (name: string, domain = "", path = "/") => {
    if (typeof document !== "undefined") {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; domain=${domain}; path=${path}`;
    }
};

export const hasCookie = (name: string) => {
    const value = "; " + document.cookie;
    const parts = value.split("; " + name + "=");
    if (parts.length == 2) {
        return true;
    }
};

export const reloadOTBanner = () => {
    if (!hasCookie("OptanonAlertBoxClosed")) {
        const otConsentSdk = document.getElementById("onetrust-consent-sdk");

        if (otConsentSdk) {
            otConsentSdk.remove();
        }

        OneTrust?.LoadBanner?.();
    }
};

export const reloadOTPreferenceCenter = () => {
    OneTrust?.ToggleInfoDisplay?.();
};

export const getCookie = (name: string) => {
    const cookieValue = document.cookie.split("; ").find((row) => row.startsWith(name + "="));
    return cookieValue ? cookieValue.split("=")[1] : "";
};
